<div data-testid="reserved-inventory-page" class="p-6 reserved-inventory-container flex-table-page">
  <!-- Header -->
  <div class="mb-6 flex-table-header">
    <h2 class="text-2xl font-semibold text-gray-800 mb-4">
      {{ "reserved_inventory_management.title" | translate }}
    </h2>
  </div>

  <!-- Search Form -->
  <app-search-form
    data-testid="reserved-inventory-search-form"
    [searchFormat]="searchConfig()"
    (formSearch)="onSearch($event)"
    (formReset)="onReset()"
  ></app-search-form>

  <!-- Data Table -->
  <div class="flex-table-section">
    <app-data-table
      data-testid="reserved-inventory-table"
      [dataSource]="reservedItems()"
      [columns]="tableColumns"
      [rows]="pageSize"
      [totalRecords]="totalRecords()"
      [loading]="loading()"
      [selection]="selectedItems()"
      [hasCheckColumn]="true"
      scrollHeight="flex"
      (selectionChange)="onSelectionChange($event)"
      (pageChange)="onPageChange($event)"
    >
    <!-- Status Template -->
    <ng-template #statusTemplate let-status let-record>
      <div class="status-cell">
        <span
          [class]="getStatusClass(status)"
          [pTooltip]="formatReservationStatus(status)"
          tooltipPosition="top"
          tooltipStyleClass="custom-tooltip"
          [showDelay]="300"
          [hideDelay]="0"
          class="status-text"
        >
          {{ formatReservationStatus(status) }}
        </span>
      </div>
    </ng-template>

    <!-- Custom Template for Reserved Quantity -->
    <ng-template
      #customTemplate
      let-value
      let-record="rowData"
      let-column="column"
    >
      @if (column.prop === "reservedQuantity") {
        <div class="flex items-center gap-2 justify-end text-xs">
          @if (record.isOverReserved) {
            <span class="material-symbols-outlined text-xs"> warning </span>
          }
          <span class="text-xs font-medium text-gray-700">
            {{ record.reservedQuantity }}
          </span>
        </div>
      } @else if (column.prop === "reservationDate") {
        <div class="flex items-center justify-center">
          <span class="text-sm text-gray-600">
            {{ formatDate(record.reservationDate) }}
          </span>
        </div>
      } @else {
        <div class="flex items-center justify-end">
          {{ value }}
        </div>
      }
    </ng-template>

    <!-- Custom Actions Template -->
    <ng-template #actionsTemplate let-record>
      <div class="flex gap-2 justify-start">
        <span
          [attr.data-testid]="'reserved-inventory-action-view-' + record.id"
          (click)="onViewDetails(record)"
          class="action-link action-view cursor-pointer"
        >
          {{ "reserved_inventory_management.actions.view" | translate }}
        </span>

        @if (record.status === "Reserved" || record.status === "Pending") {
          <span
            [attr.data-testid]="'reserved-inventory-action-release-' + record.id"
            (click)="onReleaseItem(record)"
            class="action-link action-release cursor-pointer"
          >
            {{ "reserved_inventory_management.actions.release" | translate }}
          </span>
        }

        <span
          [attr.data-testid]="'reserved-inventory-action-adjust-' + record.id"
          (click)="onAdjustQuantity(record)"
          class="action-link action-edit cursor-pointer"
        >
          {{ "reserved_inventory_management.actions.adjust" | translate }}
        </span>
      </div>
    </ng-template>
    </app-data-table>
  </div>

  <!-- Toast Messages -->
  <p-toast data-testid="reserved-inventory-toast"></p-toast>
</div>

<!-- Shared Confirmation Dialog -->
<app-confirmation-dialog
  [testId]="'reserved-inventory-confirmation-dialog'"
  [(visible)]="showConfirmationDialog"
  [title]="dialogTitle"
  [message]="dialogMessage"
  [buttons]="dialogButtons"
  (emitOnClick)="onConfirmatiButtonClick($event)"
>
</app-confirmation-dialog>
